import React, { Component } from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import appConfig from 'config/app.config';
import Game from 'components/game/game';
import Loading from 'components/loading/loading';

class GroupController extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			group: null,
			game: null,
		};
		this.unsubscribeGame = null;
		this.unsubscribeGroup = null;
	}

	/**
	 * Component mounted
	 */
	componentDidMount = () => {
		/* Subscribe to group */
		this.subscribeToGroup().then((response) => {
			if (response.status === 'success') {
				
				let gameCode = null;
				const pathName = window.location.pathname.toLowerCase();
				if (pathName.length > 0) {
					const pathNameArr = pathName.split('/');
					if (pathNameArr.length === 3 && pathNameArr[1] === 'gruppe' && pathNameArr[2].length > 0) {
						gameCode = pathNameArr[2];
					}
				}
				if (gameCode && gameCode.toLowerCase() === response.gameId) {
					/* Subscribe to game */
					this.subscribeToGame(response.gameId).then((response) => {
						if (response.status === 'success') {
							this.setState({isLoading: false});
						} else {
							this.props.handleLogout();
							this.setState({isLoading: false});		
						}
					});
				} else {
					this.props.handleLogout();
					this.setState({isLoading: false});	
				}
			} else {
				this.props.handleLogout();
				this.setState({isLoading: false});
			}
		});
	};

	/**
	 * Subscribe to group
	 * @returns {Promise}
	 */
	subscribeToGroup = () => {
		/* Cancel previous subscription */
		if (this.unsubscribeGroup !== null) this.unsubscribeGroup();
		
		return new Promise((resolve) => {
			const db = firebase.firestore();
			this.unsubscribeGroup = db.collection(appConfig.groupsDbName).doc(this.props.userId).onSnapshot((doc) => {
				if (doc.exists) {
					/* Subscribed succesfully */
					this.setState({group: {id: doc.id, ...doc.data()}}, () => {
						resolve({status: 'success', gameId: doc.data().gameId});		
					});
				} else {
					/* Error: could not subscribe to group */
					resolve({
						status: 'error', 
						error: 'Could not subscribe to group with id ' + this.props.userId + '.'
					});
				}
			});
		});
	};

	/**
	 * Subscribe to game
	 * @param {string} gameId 
	 * @returns 
	 */
	subscribeToGame = (gameId) => {
		/* Cancel previous subscription */
		if (this.unsubscribeGame !== null) this.unsubscribeGame();

		return new Promise((resolve) => {
			const db = firebase.firestore();
			this.unsubscribeGroup = db.collection(appConfig.gamesDbName).doc(gameId).onSnapshot((game) => {
				if (game.exists) {
					/* Subscribed succesfully */
					this.setState({game: {...game.data(), id: gameId}}, () => {
						resolve({status: 'success'});
					});
				} else {
					resolve({
						status: 'error', 
						error: 'Could not subscribe to game with id ' + gameId + '.'
					});
				}
			});
		});
	};
	
	/**
	 * Update group
	 * @param {object} updates
	 * @returns {promise}
	 */
	updateGroup = (updates) => {
		const groupId = this.props.userId;
		const db = firebase.firestore();
		const groupRef = db.collection(appConfig.groupsDbName).doc(groupId);
		return groupRef.update(updates);
	};

	/**
	 * Component will unmount
	 */
	componentWillUnmount = () => {
		/* Unsubscribe from game */
		if (this.unsubscribeGame !== null) this.unsubscribeGame();

		/* Unsubscribe from group */
		if (this.unsubscribeGroup !== null) this.unsubscribeGroup();
	};

	 /**
	 * Render component
	 */
	 render() {
		/* Loading */
		if (this.state.isLoading || !this.state.game || !this.state.group) {
			return (
				<Loading 
					role="player"
					languageId={this.props.languageId}
					handleLogout={this.props.handleLogout} 
				/>
			);
		};

		/* Game page */
		return (
			<Game 
				languageId={this.props.languageId}
				deviceInfo={this.props.deviceInfo}
				gameData={this.state.game}
				groupData={this.state.group}
				updateGroup={this.updateGroup}
				setLanguageId={this.props.setLanguageId}
				handleLogout={this.props.handleLogout}
			/>
		);
	 }
}

GroupController.propTypes = {
	languageId: PropTypes.string.isRequired,
	userId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	setLanguageId: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired
};

export default GroupController;
